import { z } from 'zod';

import type { CheckoutOutcomeBlock } from '../business/checkout_outcome/checkout_outcome_schema.js';
import { chatUiBase } from './schema/base.js';

/**
 * The parse-time migration of the kinds that left the contract and still live
 * in persisted history (#5514). `hotel_confirmation`, `bus_confirmation` and
 * the receipt of `rental_reservation` simply drop out of the turn, like any
 * retired kind (the per-block salvage of the reader). The one thing an old
 * block carried that history still needs is the 1-Click outcome: a
 * `rental_reservation` with the checkout's `challengeId` (#5360) said «the
 * request went in», so it becomes the `checkout_outcome: requested` the agent
 * emits today. Without it, the reopened car card of those turns would read as
 * a failure.
 */
const LegacyRentalReservationSchema = z.object({
  ...chatUiBase,
  kind: z.literal('rental_reservation'),
  challengeId: z.string().min(1),
  tripId: z.string().min(1).optional(),
});

/** One persisted block in today's contract vocabulary; anything else passes
 *  through untouched for the regular validation to judge. */
export function upgradeRetiredBlock(raw: unknown): unknown {
  const rental = LegacyRentalReservationSchema.safeParse(raw);
  if (!rental.success) return raw;
  const { id, challengeId, tripId } = rental.data;
  const outcome: CheckoutOutcomeBlock = {
    id,
    kind: 'checkout_outcome',
    challengeId,
    outcome: 'requested',
    ...(tripId ? { tripId } : {}),
  };
  return outcome;
}
